var map = {
	"./Daenerys-GOT.jpg": 2973,
	"./Jinx.jpg": 1958,
	"./black-widow-b.jpg": 984,
	"./boxing_2.jpg": 1699,
	"./boxing_3.jpg": 9331,
	"./boxing_7.jpg": 1202,
	"./dr-strange.jpg": 6098,
	"./eminem-c.jpg": 5515,
	"./fire.jpg": 1215,
	"./iron-man.jpg": 651,
	"./moon-knigh-2t.jpg": 6112,
	"./poster-mandalorian.jpg": 8593,
	"./poster-neymar.jpg": 4162,
	"./poster_ftwd.jpg": 9573,
	"./poster_spiderman.jpg": 4154,
	"./poster_star wars 7.png": 506,
	"./poster_star wars.jpg": 2485,
	"./poster_twd.jpg": 4399,
	"./poster_xavi.jpg": 3205,
	"./scarlet-witch.jpg": 1004,
	"./unfamous.jpg": 1014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5571;